module.exports = __webpack_public_path__ + "static/media/shop-best-deal.0d65e4e0.png";